import React, { useState, useEffect } from "react";
import WelcomeCard from "../../components/common/WelcomeCard";
import { LiaBlogSolid } from "react-icons/lia";
import { FaEdit, FaTrash, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import Loader from "../../components/common/Loader";
import AddSubSubserviceModal from "../../components/modals/AddSubSubserviceModal";
import EditSubSubserviceModal from "../../components/modals/EditSubSubserviceModal";
import toast from "react-hot-toast";

const SubSubService = () => {
  const [subSubServiceList, setSubSubServiceList] = useState([]);
  const [filteredSubSubServiceList, setFilteredSubSubServiceList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [subServiceList, setSubServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedSubService, setSelectedSubService] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedSubSubservice, setSelectedSubSubservice] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);

  const fetchSubSubServices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/subsubservices/get-all-subsubservices`
      );
      const data = Array.isArray(response.data.data) ? response.data.data : [];
      setSubSubServiceList(data);
      setFilteredSubSubServiceList(data);
    } catch (err) {
      console.error("Error fetching subsubservices:", err);
      setError("Failed to load subsubservices");
      toast.error("Failed to load subsubservices");
    } finally {
      setLoading(false);
    }
  };

  const fetchSubServices = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/subservices/get-all-subservices`
      );
      const data = Array.isArray(response.data.data) ? response.data.data : [];
      setSubServiceList(data);

      const uniqueServices = Array.from(
        new Map(data.map((s) => [s.service._id, s.service])).values()
      );
      setServiceList(uniqueServices);
    } catch (err) {
      console.error("Failed to fetch subservices:", err);
      toast.error("Failed to load subservices");
    }
  };

  useEffect(() => {
    fetchSubSubServices();
    fetchSubServices();
  }, []);

const handleServiceChange = (serviceId) => {
  setSelectedService(serviceId);
  setSelectedSubService("");

  if (!serviceId) {
    setFilteredSubSubServiceList(subSubServiceList);
    setCurrentPage(1);
    return;
  }

  const filteredSubServices = subServiceList.filter(
    (sub) => sub?.service?._id === serviceId
  );

  const filteredSubSub = subSubServiceList.filter((subsub) =>
    subsub?.subservice &&                         
    filteredSubServices.some((s) => s?._id === subsub.subservice._id)
  );

  setFilteredSubSubServiceList(filteredSubSub);
  setCurrentPage(1);
};

const handleSubServiceChange = (subServiceId) => {
  setSelectedSubService(subServiceId);

  if (!subServiceId) {
    handleServiceChange(selectedService);
    return;
  }

  const filteredSubSub = subSubServiceList.filter(
    (subsub) => subsub?.subservice?._id === subServiceId  
  );

  setFilteredSubSubServiceList(filteredSubSub);
  setCurrentPage(1);
};


  const handleReset = () => {
    setSelectedService("");
    setSelectedSubService("");
    setFilteredSubSubServiceList(subSubServiceList);
    setCurrentPage(1);
    toast.success("Filter cleared");
  };

  const handleSubSubserviceAdded = (newItem) => {
    if (!newItem) return;
    setSubSubServiceList((prev) => [newItem, ...prev]);
    setFilteredSubSubServiceList((prev) => [newItem, ...prev]);
  };

  const handleSubSubserviceUpdated = (updatedItem) => {
    if (!updatedItem) return;
    setSubSubServiceList((prev) =>
      prev.map((s) => (s?._id === updatedItem?._id ? updatedItem : s))
    );
    setFilteredSubSubServiceList((prev) =>
      prev.map((s) => (s?._id === updatedItem?._id ? updatedItem : s))
    );
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this sub-subservice?")) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/subsubservices/delete-subsubservice/${id}`
      );
      setSubSubServiceList((prev) => prev.filter((item) => item?._id !== id));
      setFilteredSubSubServiceList((prev) => prev.filter((item) => item?._id !== id));
      toast.success("Sub-Subservice deleted successfully");
    } catch (err) {
      console.error("Failed to delete subsubservice:", err);
      toast.error("Failed to delete sub-subservice");
    }
  };

  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => setOpenAddModal(false);

  const handleOpenEditModal = (item) => {
    setSelectedSubSubservice(item);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setSelectedSubSubservice(null);
    setOpenEditModal(false);
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSubSubServiceList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSubSubServiceList.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  // ✅ Subservices filtered by selected service (for the subservice dropdown)
  const filteredSubServicesForDropdown = selectedService
    ? subServiceList.filter((sub) => sub.service._id === selectedService)
    : subServiceList;

  if (error) {
    return <div className="text-center text-red-500 mt-10">{error}</div>;
  }

  return (
    <>
      {/* ✅ Pass allServices to both modals */}
      <AddSubSubserviceModal
        isOpen={openAddModal}
        onClose={handleCloseAddModal}
        onSubSubserviceAdded={handleSubSubserviceAdded}
        allSubservices={subServiceList}
        allServices={serviceList}
      />

      {selectedSubSubservice && (
        <EditSubSubserviceModal
          isOpen={openEditModal}
          onClose={handleCloseEditModal}
          subsubservice={selectedSubSubservice}
          onSubSubserviceUpdated={handleSubSubserviceUpdated}
          allSubservices={subServiceList}
          allServices={serviceList}
        />
      )}

      <div className="p-4">
        <WelcomeCard />

        <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
          <h1 className="text-xl font-semibold text-[#000000] tracking-wider">
            Sub-SubServices List
          </h1>

          <div className="flex items-center gap-2 flex-wrap">

            {/* ✅ Service Dropdown */}
            <select
              value={selectedService}
              onChange={(e) => handleServiceChange(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
            >
              <option value="">All Services</option>
              {serviceList.map((srv) => (
                <option key={srv._id} value={srv._id}>
                  {srv.serviceName || srv.name}
                </option>
              ))}
            </select>

            {/* ✅ Subservice Dropdown — auto-filtered by selected service */}
            <select
              value={selectedSubService}
              onChange={(e) => handleSubServiceChange(e.target.value)}
              disabled={!selectedService}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">All SubServices</option>
              {filteredSubServicesForDropdown.map((sub) => (
                <option key={sub._id} value={sub._id}>
                  {sub.subserviceName}
                </option>
              ))}
            </select>

            <button
              onClick={handleReset}
              className="bg-gray-300 text-gray-700 px-3 py-2 rounded-md font-medium hover:bg-gray-400 transition"
            >
              Reset
            </button>

            <button
              onClick={handleOpenAddModal}
              className="flex justify-center items-center bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white font-semibold tracking-wider py-2 px-4 rounded-md hover:bg-red-600 transition duration-300 ease-in-out"
            >
              <LiaBlogSolid size={24} className="mr-2" /> Add Sub-SubService
            </button>
          </div>
        </div>

        {loading ? (
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 w-full p-4 mt-10">
            <Loader /> <span className="ml-2">Loading Sub-Subservices...</span>
          </div>
        ) : filteredSubSubServiceList.length === 0 ? (
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 w-full p-4">
            No Sub-SubServices found.
          </div>
        ) : (
          <>
            <div className="container mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {currentItems.map((sub) => (
                  <div
                    key={sub?._id}
                    className="bg-white shadow-md rounded-lg p-4 transition transform hover:scale-105 relative"
                  >
                    <h2 className="text-xl font-bold text-center mb-2">
                      {sub?.subsubserviceName}
                    </h2>
                    <h2 className="text-sm font-bold text-center mb-2 text-orange-500">
                      {sub?.subservice?.subserviceName}
                    </h2>

                    {sub?.images?.length > 0 && (
                      <img
                        src={sub.images[0]}
                        alt={sub.subsubserviceName}
                        className="w-full h-40 object-cover rounded mb-2"
                      />
                    )}

                    {sub?.description?.length > 0 && (
                      <div className="text-gray-600 text-sm text-center mb-3">
                        {sub.description.map((desc, i) => (
                          <p
                            key={i}
                            className="mb-2 line-clamp-2"
                            dangerouslySetInnerHTML={{ __html: desc }}
                          />
                        ))}
                      </div>
                    )}

                    <div className="flex justify-center space-x-4 mt-2">
                      <button
                        onClick={() => handleOpenEditModal(sub)}
                        className="text-blue-500 hover:text-blue-700"
                        title="Edit Sub-Subservice"
                      >
                        <FaEdit size={20} />
                      </button>
                      <button
                        onClick={() => handleDelete(sub?._id)}
                        className="text-red-500 hover:text-red-700"
                        title="Delete Sub-Subservice"
                      >
                        <FaTrash size={20} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {totalPages > 1 && (
              <div className="flex justify-center items-center mt-8 space-x-2">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`p-2 rounded-md ${currentPage === 1
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-orange-500 text-white hover:bg-orange-600"}`}
                >
                  <FaChevronLeft />
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => paginate(page)}
                    className={`px-3 py-1 rounded-md ${currentPage === page
                      ? "bg-orange-500 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                  >
                    {page}
                  </button>
                ))}

                <button
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className={`p-2 rounded-md ${currentPage === totalPages
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-orange-500 text-white hover:bg-orange-600"}`}
                >
                  <FaChevronRight />
                </button>
              </div>
            )}

            {filteredSubSubServiceList.length > 0 && (
              <div className="text-center mt-4 text-gray-600">
                Showing {indexOfFirstItem + 1} to{" "}
                {Math.min(indexOfLastItem, filteredSubSubServiceList.length)} of{" "}
                {filteredSubSubServiceList.length} Sub-SubServices
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SubSubService;